module.exports = __webpack_public_path__ + "images/help/icn-flightboard-ecd4a66f7c67d2bd9eebd52396b535c2.png";